module.exports = __webpack_public_path__ + "static/media/SWSCRC6-12.460ceb5c.mp3";